import {Component, Input, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {FileReference} from '../../../class/file-reference';
import {Router} from '@angular/router';
import {NbDialogRef, NbWindowService} from '@nebular/theme';
import {PdfViewerComponentComponent} from '../../pdf-viewer-component/pdf-viewer-component.component';

@Component({
  selector: 'app-file-reference-dialog',
  templateUrl: './file-reference-dialog.component.html',
  styleUrls: ['./file-reference-dialog.component.css']
})
export class FileReferenceDialogComponent extends BaseDialog<FileReference> implements OnInit{

  @Input()
  files: FileReference[];

  constructor(dialogRef: NbDialogRef<FileReference>, route: Router, private windowService: NbWindowService) {
    super(dialogRef, route);
  }

  ngOnInit() {
  }

  fileSelected(file:FileReference){
    this.close(file);
  }

  openFileInWidow(file: FileReference){
    this.windowService.open(PdfViewerComponentComponent,{
      title: file.fileName,
      context:{
        documentID: file.id
      }
    })
  }
}
